<template>
  <div>
    <h2>
      Historic Milk Production
      <comments field-name='heading_historic_milk_production' :isReadOnly="isReadOnly"></comments>
    </h2>


    <div class="step-section" v-for="(data, index) in getChartData('historic_milk_production')" :key="'histo_'+index">
      <h3 class="text-left"> {{ data.Shed }}</h3>
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td width="70%">Predicted Total Production {{ seasonStartYear-1 }}/{{ seasonStartYear.toString().substr(-2) }} KgMS</td>
            <td width="30%">{{ data["Predicted Total Production KgMS Last Season"] }}</td>
          </tr>
          <tr>
            <td width="70%">Predicted Per Cow Production {{ seasonStartYear-1 }}/{{ seasonStartYear.toString().substr(-2) }} KgMS</td>
            <td width="30%">{{ data["Predicted Per Cow Production KgMS last Season"] }}</td>
          </tr>
          <tr>
            <td width="70%">Actual Total Production {{ seasonStartYear-2 }}/{{ seasonStartYear.toString().substr(-2) -1 }} KgMS</td>
            <td width="30%">{{ data["Actual Total Production KgMS Pervious Season"] }}</td>
          </tr>
          <tr>
            <td width="70%">Actual Per Cow Production {{ seasonStartYear-2 }}/{{ seasonStartYear.toString().substr(-2) -1 }} KgMS</td>
            <td width="30%">{{ data["Actual Per Cow Production KgMS Previous Season"] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="clearfix" :style="{ width: widthForRow(getFieldValue('FARMS')) + 'px' }">
      <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id">
        <h3>{{ farm.farm_label }}</h3>

        <number-input :label="`Actual Total Production ${seasonStartYear - 1}/${seasonStartYear.toString().substr(-2)} Kg/MS`"
                                                  :field-name="`farm_${farm.id}-kgms_ls`"
                                                  :add-comment="true"
                                                  :disabled="isReadOnly">
        </number-input>
        <number-input :label="`Target Total Production ${seasonStartYear}/${(seasonStartYear + 1).toString().substr(-2)} Kg/MS`"
                                                  :field-name="`farm_${farm.id}-pred_kgms_ts`"
                                                  :add-comment="true"
                                                  :disabled="isReadOnly">
        </number-input>

      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-6 col-md-offset-3">
        <label for="total_spend">$/KgMS - Client's total dairy spend {{ seasonStartYear-1 }}/{{ seasonStartYear.toString().substr(-2) }} per Kilogram of Milk Solids</label>
        <input type="text" class="form-control" id="total_spend" :disabled="true" :value="getTotalKgMS">
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <h3>Season Spend Breakdown</h3>
        <div v-if="(getChartData('season_spend_breakdown') || []).length > 0 ">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Product group</th>
                <th>Total</th>
                <th>Percent</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ssb, index) in getChartData('season_spend_breakdown')" :key="index">
                <td class="text-left">{{ ssb['product_group'] }}</td>
                <td class="text-left">{{ ssb['total'] }}</td>
                <td class="text-left">{{ ssb['percent'] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <h3>Warning: These LA Invoice records are included but are not linked to an animal record</h3>
        <p>
          These invoices associated with large animal products are included in
          the above spend breakdown however the invoices are not linked to an
          animal record. These invoices may or may not be related to dairy
          spend.
        </p>
        <div v-if="(getChartData('season_spend_breakdown_warn') || []).length > 0 ">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Inv. Date</th>
                <th>Account</th>
                <th>Product</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ssbw, index) in getChartData('season_spend_breakdown_warn')" :key="index">
                <td class="text-left">{{ ssbw.invdate }}</td>
                <td class="text-left">{{ ssbw.ledgeraccount }}</td>
                <td class="text-left">{{ ssbw.name }}</td>
                <td class="text-left">{{ ssbw.total }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'HistoricProduction',
  mixins: [ baseComponent ],
  computed: {
    getTotalKgMS: function() {
      let totalPerFarm = 0

      for (let farm of this.getFieldValue('FARMS')) {
        totalPerFarm += this.getFieldValue(`farm_${farm.id}-kgms_ls`) || 0
      }

      if (totalPerFarm > 0 && this.getChartData('previous_season_spend')) {
        return '$' + (this.getChartData('previous_season_spend') / totalPerFarm).toFixed(3)
      }
      return '-'
    },
  }
};
</script>

<style>
.farm-fields {
  float: left;
  width: 350px;
  margin-right: 3em;
}
</style>
